export default function SiteFooter() {
  const groups = [
    {
      title: "内容版块",
      links: ["今日焦点", "实锤讨论", "追更时间线", "反转复盘", "后续进展速报"],
    },
    {
      title: "专题合集",
      links: ["年度复盘档案", "塌房事件档案", "直播翻车合集", "声明解读册", "澄清档案"],
    },
    {
      title: "关于本站",
      links: ["栏目介绍", "审稿规范", "纠错与反证", "联系编辑部"],
    },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-12">
          {/* 品牌 */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center bg-primary-500 text-background-50">
                <i className="ri-eye-off-fill text-xl" />
              </span>
              <span className="font-heading text-2xl font-black tracking-tight text-foreground-950">
                9黑料网
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              一个以「深挖、实锤讨论、时间线、后续进展、反转复盘」为主线的内容聚合站，力求把每个事件讲清楚、铺平、说透。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2 text-xs text-foreground-600">
              <a href="#top" className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 hover:bg-background-100">
                内容规范
              </a>
              <a href="#top" className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 hover:bg-background-100">
                版权说明
              </a>
              <a href="#top" className="rounded-full border border-background-300 bg-background-50 px-3 py-1.5 hover:bg-background-100">
                免责声明
              </a>
            </div>
          </div>

          {/* 链接 */}
          <div className="col-span-2 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-7 lg:grid-cols-3">
            {groups.map((g) => (
              <div key={g.title}>
                <h4 className="mb-3 font-heading text-sm font-bold text-foreground-950">{g.title}</h4>
                <ul className="space-y-2">
                  {g.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-xs text-foreground-600 hover:text-foreground-950">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 rounded-md border border-background-300 bg-background-100 p-4">
          <p className="text-[11px] leading-relaxed text-foreground-600">
            <b className="text-foreground-800">审稿与免责提示：</b>
            本站内容均为对公开信息与网络素材的整理、梳理与讨论，用于娱乐与信息梳理用途，不构成对任何具体主体的事实定性或指控。
            站内帖子与复盘仅代表整理者立场，欢迎通过「反证」渠道提供更完整上下文。请理性讨论，勿据此对任何个人实施网暴或线下骚扰。
            素材如涉及权益，请联系处理。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:justify-between">
          <p>© 2026 9黑料网 · 深挖实锤 · 时间线复盘 · 后续进展速报。保留所有权利。</p>
          <p className="flex items-center gap-1">
            聚合门户 · 轻杂志排版 <i className="ri-circle-fill text-[4px] text-accent-600" /> 更新至 2026-09-06
          </p>
        </div>
      </div>
    </footer>
  );
}